import OfferList from './OfferList'

export default OfferList
